export enum IRoles {
    ADMIN = 1,
    GUEST = 2
}